module.exports = __webpack_public_path__ + "static/lix.4ae7c876.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lix.png
// module id = 1363
// module chunks = 174994552580003 196563901955997